import { inject } from '@angular/core';
import { ExtendedAuthService } from '../../util/auth/auth.service';
import { Route } from '@angular/router';

export const redirect = (url: string) => () => {
  window.location.href = url;
  return `/redirect#${encodeURIComponent(url)}`;
};

export const signupRedirect = () => {
  return () => {
    const authService = inject(ExtendedAuthService);
    authService.signup().subscribe();
    return `/redirect?flow=signup`;
  };
};

export const embed = (
  path: string,
  src: string,
  options: { scripts?: string[] } = {},
): Route => ({
  path,
  data: {
    src,
    ...options,
  },
  loadComponent: () => import('./embed/embed.component'),
});
